import {
  createListenerMiddleware,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import { enqueueError } from '../redux/errorSlice';
import { isFetchBaseQueryError } from '../services/isFetchBaseQueryError';
import { EnqueueRequest } from '../types/errors';
import { AppDispatch, AppState } from '../redux/store';
import { getMaintenanceInfo } from './maintenance';
import { setMaintenanceInfo } from '../redux/maintenanceSlice';
import { logger } from '../services/logger';

/**
 * AsyncThunk の失敗 (= 通信エラー) 時にエラーを登録するミドルウェア
 */
const listener = createListenerMiddleware<AppState, AppDispatch>();

let maintenanceChecking = false;
listener.startListening({
  matcher: isRejectedWithValue(),

  async effect(action, { dispatch }) {
    const error = action.payload as EnqueueRequest;

    // 通信エラーでない場合はモーダルを即時表示
    if (isFetchBaseQueryError(error)) {
      // ログイン認証情報エラー判定
      if (error.status === 401) {
        return;
      }

      // メンテナンスモード判定
      if (
        error.status === 'TIMEOUT_ERROR' ||
        error.status === 'FETCH_ERROR' ||
        error.status === 503
      ) {
        // メンテナンス情報リクエスト中は新たにリクエストを実行しない
        if (maintenanceChecking) {
          return;
        }

        try {
          maintenanceChecking = true;
          const maintenance = await getMaintenanceInfo();
          if (maintenance.isMaintenance) {
            dispatch(setMaintenanceInfo(maintenance));
            return;
          }
        } catch (maintenanceCheckError) {
          logger.warn(
            'Failed to fetch maintenance.json',
            maintenanceCheckError
          );
        } finally {
          maintenanceChecking = false;
        }
      }
    }

    dispatch(enqueueError(error));
  },
});

export const fetchErrorHandlingMiddleware = listener.middleware;
